import { makeAutoObservable } from 'mobx';
import { Reseller } from '../../models';

export class ResellerUnitData {

    constructor(reseller?: Reseller) {
        if (reseller) {
        }
        makeAutoObservable(this)
    }

    // ******************
    // property
    // ******************


    // ******************
    // function
    // ******************

}
